export const articleListStyle = theme => ({
  paging: {
    margin: theme.spacing(2,0),
  },

  pagingUl: {
    justifyContent: 'center',
  },
})
